import { c as _c } from "react/compiler-runtime";
import React from "react";
import * as LucideIcons from "lucide-react";
import { StaticCardGridProps } from "./StaticCardGrid.props";
import { cn } from "@/lib/utils";
import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";
import { Reveal } from "@/components/atoms/Reveal";
export const StaticCardGrid = t0 => {
  const $ = _c(9);
  const {
    cards,
    cardsPerRow: t1
  } = t0;
  const cardsPerRow = t1 === undefined ? 3 : t1;
  let T0;
  let t2;
  if ($[0] !== cardsPerRow) {
    const gridColsClass = {
      2: "md:grid-cols-2",
      3: "md:grid-cols-2 lg:grid-cols-3",
      4: "md:grid-cols-2 lg:grid-cols-4"
    }[cardsPerRow] || "md:grid-cols-2 lg:grid-cols-3";
    T0 = Box;
    t2 = cn("grid grid-cols-1 gap-6 md:gap-8", gridColsClass);
    $[0] = cardsPerRow;
    $[1] = T0;
    $[2] = t2;
  } else {
    T0 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cards) {
    t3 = cards?.filter(_temp).map(_temp2);
    $[3] = cards;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== T0 || $[6] !== t2 || $[7] !== t3) {
    t4 = <T0 className={t2}>{t3}</T0>;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(card) {
  return card.title;
}
function _temp2(card_0, index) {
  const IconComponent = card_0.icon ? (LucideIcons as unknown as Record<string, React.ComponentType<{
    size?: number;
    strokeWidth?: number;
    className?: string;
  }>>)[card_0.icon] : null;
  return <Reveal key={card_0._key} delayMs={Math.min(index, 5) * 90} className="h-full"><Box className={cn("group relative flex h-full overflow-hidden rounded-2xl p-6 md:p-8", "bg-white/5 border border-white/10", "backdrop-blur-sm shadow-xl", "transition duration-300 ease-out", "hover:-translate-y-1 hover:bg-white/10 hover:border-white/20 hover:shadow-2xl")}>{IconComponent && <Box className="flex-shrink-0 mr-4"><Box className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-primary/20"><IconComponent size={28} strokeWidth={1.5} /></Box></Box>}<Box className="flex-1 min-w-0"><Text as="p" className="text-lg font-bold leading-tight md:text-xl">{card_0.title}</Text>{card_0.blurb && <Text as="p" className="mt-2 text-sm opacity-80 leading-relaxed">{card_0.blurb}</Text>}</Box></Box></Reveal>;
}